import React, {Component} from 'react';
import '../../style.css';
import {PageHeader, Space, Card, Typography, Button, message, Input, Modal, Tag, Tooltip, Form} from "antd";
import {fetchPost, fetchPostFile} from "../../static/util/fetch";
import FileViewer from 'react-file-viewer';
const { Paragraph } = Typography;

class OrganizationItem extends Component {
    constructor(props) {
        super(props);
        this.state = {
            companyName:this.props.companyName,
            companyId:this.props.companyId,
            status:0,//是否有产学研
            organizationItem:[
                {
                    school: null,
                    companyName: "公司2",
                    status: 0,
                    count: "0",
                    average: "0"
                }
            ],
            school:'',
            edit_status:false,
            fileStream:'',
            preview_visible:false,
            fileStream_upload:'',
            fileField:[],
            upload_visible:false,
            uploadFile_visible:false,
            checkStatus:false,
        }
        this.schoolChange = this.schoolChange.bind(this);
        this.hideModal = this.hideModal.bind(this);
    }
    componentDidMount() {
        fetchPost(global.constants.getOrganizationItemGetP,{companyId:this.state.companyId})
            .then(
                res=>{
                    if(res.code === 200){
                        this.setState(()=>({
                            organizationItem:res.data,
                            school:res.data.school,
                            status:res.data.status === 1
                        }))
                        if(res.data.school === null){
                            this.setState(()=>({
                                edit_status:false,
                            }))
                        }else{
                            this.setState(()=>({
                                edit_status:true,
                            }))
                        }
                    }
                }
            )
    }
    edit(){
        fetchPost(global.constants.getOrganizationItemGetP, {companyId:this.state.companyId})
            .then(
                res => {
                    if(res.code === 200) {
                        this.setState(()=>({
                            school:res.data.school,
                            status:true,
                            edit_status:false,
                        }))
                    }
                }
            )
    }
    submit(){
        let params = {
            companyId:this.state.companyId,
            companyName:this.state.companyName,
            school:this.state.school,
            status:this.state.school === null || this.state.school === ''? 0:1
        }
        fetchPost(global.constants.addOrganizationItem,params)
            .then(
                res => {
                    if(res.code === 200) {
                        message.success("添加成功").then()
                        fetchPost(global.constants.getOrganizationItemGetP, {companyId:this.state.companyId})
                            .then(
                                res => {
                                    if(res.code === 200) {
                                        this.setState(()=>({
                                            school:res.data.school,
                                            status:res.data.status === 1
                                        }))
                                        if(res.data.school === null){
                                            this.setState(()=>({
                                                edit_status:false,
                                            }))
                                        }else{
                                            this.setState(()=>({
                                                edit_status:true,
                                            }))
                                        }
                                    }
                                }
                            )
                    }
                }
            )
    }
    schoolChange(e){
        const value = e.target.value
        this.setState(()=>({
            school:value
        }))
    }
    handleExportClick(){
        let params = {
            companyId:this.state.companyId
        }
        fetchPost(global.constants.exportOrganizationItemP,params)
            .then(
                res => {
                    if(res.code === 200) {
                        message.success("已在云端生成，请下载").then()
                    }
                    else{
                        message.info("生成失败，请先添加数据").then()
                    }
                }
            )
    }
    download(){
        let params = {
            companyId:this.state.companyId,
            projectId:0,
            productId:0,
            patentId:0,
            otherId:0,
            remark:'',
            url: '/create/'+this.state.companyName+'/2-22企业研究开发组织管理水平指标逐项说明.doc',
            fileName: '企业研究开发组织管理水平指标逐项说明.doc'
        }
        fetchPostFile(global.constants.downloadFile,params)
            .then(
                res=>{
                    res.blob().then(
                        blob=>{
                            let blobUrl = window.URL.createObjectURL(blob);
                            let aElement = document.getElementById('downloadDiv'); //获取a标签元素
                            let filename = '2-22企业研究开发组织管理水平指标逐项说明.doc';//设置文件名称
                            aElement.href = blobUrl;//设置a标签路径
                            aElement.download = filename;
                            aElement.click();
                            window.URL.revokeObjectURL(blobUrl);
                        }
                    )
                }
            )
    }
    hideModal(){
        this.setState(()=>({
            preview_visible:false,
            upload_visible:false,
        }))
    }
    handlePreviewClick(){
        let params={
            companyId:this.state.companyId,
            fileName:'2-22企业研究开发组织管理水平指标逐项说明.doc'
        }
        fetchPost(global.constants.checkFileProcess, params)
            .then(
                res=> {
                    if (res.code === 200) {
                        let params = {
                            companyId:this.state.companyId,
                            projectId:0,
                            productId:0,
                            patentId:0,
                            otherId:0,
                            remark:'',
                            url: '/create/'+this.state.companyName+'/企业研究开发组织管理水平指标逐项说明.pdf',
                            fileName: '企业研究开发组织管理水平指标逐项说明.pdf'
                        }
                        fetchPostFile(global.constants.previewFile,params)
                            .then(
                                res=>{
                                    res.blob().then(
                                        blob=> {
                                            let blobUrl = window.URL.createObjectURL(blob);
                                            this.setState(()=>({
                                                fileStream:blobUrl,
                                                preview_visible:true,
                                            }))
                                        })
                                }
                            )
                    }else{
                        message.info("云端不存在该文件，请先生成！").then()
                    }
                }
            )
    }
    hideModalTwo(){
        this.setState(()=>({
            uploadFile_visible:false,
        }))
    }
    handleUploadClick(e){
        this.setState(()=>({
            upload_visible:true,
        }))
        let params = {
            companyId:this.state.companyId,
            projectId:0,
            productId:0,
            patentId:0,
            otherId:0,
            remark:'企业研究开发组织管理水平指标逐项说明',
            url:'',
        }
        fetchPost(global.constants.checkFile, params)
            .then(
                res => {
                    if(res.code === 200){
                        let params = {
                            companyId:this.state.companyId,
                            projectId:0,
                            productId:0,
                            patentId:0,
                            otherId:0,
                            remark:'企业研究开发组织管理水平指标逐项说明',
                            url: '',
                            fileName: ''
                        }
                        fetchPostFile(global.constants.previewFile,params)
                            .then(
                                res=>{
                                    res.blob().then(
                                        blob=> {
                                            let blobUrl = window.URL.createObjectURL(blob);
                                            this.setState(()=>({
                                                fileStream_upload:blobUrl,
                                                checkStatus:true
                                            }))
                                        })
                                }
                            )
                    }
                    else{
                        this.setState(()=>({
                            fileStream_upload:'',
                            checkStatus:false,
                        }))
                    }
                })
    }
    fileInput(){
        this.setState(()=>({
            fileField:document.querySelector("input[type='file'][name='file']"),
            uploadFile_visible:true,
        }))
    }
    uploadFile(){
        const formdata = new FormData();
        formdata.append('file', this.state.fileField.files[0]);
        formdata.append('companyId',this.state.companyId);
        formdata.append('projectId',0);
        formdata.append('productId',0);
        formdata.append('patentId',0);
        formdata.append('otherId',0);
        formdata.append('remark','企业研究开发组织管理水平指标逐项说明');
        if (!(/pdf$/i.test(this.state.fileField.files[0].name))) {
            alert("只允许上传pdf格式的文件")
        } else{
            fetch(global.constants.uploadFile, {
                method: 'POST',
                body: formdata,
                mode: 'cors',
                credentials: 'include',
            })
                .then(res => res.json())
                .then(
                    res => {
                        if(res.code === 200){
                            message.success("上传成功").then();
                            let params = {
                                companyId:this.state.companyId,
                                projectId:0,
                                productId:0,
                                patentId:0,
                                otherId:0,
                                remark:'企业研究开发组织管理水平指标逐项说明',
                                url: '',
                                fileName: ''
                            }
                            fetchPostFile(global.constants.previewFile,params)
                                .then(
                                    res=>{
                                        res.blob().then(
                                            blob=> {
                                                let blobUrl = window.URL.createObjectURL(blob);
                                                this.setState(()=>({
                                                    fileStream_upload:blobUrl,
                                                    uploadFile_visible:false,
                                                    checkStatus:true,
                                                }))
                                            })
                                    }
                                )
                        }
                    })
        }
    }
    deleteUpload(){
        let params = {
            companyId:this.state.companyId,
            projectId:0,
            productId:0,
            patentId:0,
            otherId:0,
            remark:'企业研究开发组织管理水平指标逐项说明',
            url: '',
        }
        fetchPost(global.constants.deleteFile,params)
            .then(
                res=>{
                    if(res.code === 200){
                        message.success("删除成功").then()
                        this.setState(()=>({
                            checkStatus:false,
                        }))
                    }
                }
            )
    }
    render() {
        const Anchor = props => {
            return (
                <a {...props}>{props.children}</a>
            );
        };
        return (
            <div>
                <Anchor id="downloadDiv" style={{display: 'none'}}/>
                <div className="content-page-header">
                    <PageHeader
                        ghost={false}
                        title="研究开发组织管理水平指标逐项说明"
                        subTitle='可编辑生成或上传，只允许上传50M以内的pdf格式的文件'
                        extra={[
                            <Button type="primary"  onClick={this.handleUploadClick.bind(this)}>上传</Button>,
                            <Button
                                onClick={this.handleExportClick.bind(this)}>生成</Button>,
                            <Tooltip title="预览生成的文件">
                                <Button
                                    type="primary"
                                    onClick={this.handlePreviewClick.bind(this)}
                                >预览</Button>
                            </Tooltip>,
                        ]}
                    >
                    </PageHeader>
                </div>
                <div>
                    <Paragraph>
                        <pre>
                            注：若两种方式的文件均存在，文件合成时系统自动选取上传的文件。<br/>
                            &nbsp;&nbsp;&nbsp;&nbsp;若无产学研协议，可以不填。
                        </pre>
                    </Paragraph>
                </div>
                <Space direction="vertical" className="content-style">
                    <Card bordered={true} style={{border:'solid  1px #7F9DB9'}} >
                        <div className='word'>
                            <Paragraph className='word-title'>企业研究开发组织管理水平逐项说明</Paragraph>
                        </div>
                        {
                            this.state.status === true?
                                <table border="1" className='table'>
                                    <tr>
                                        <td height="60;" colSpan="1" align='center'>序号</td>
                                        <td colSpan="2" width="40%" align='center'>研究开发组织管理内容</td>
                                        <td colSpan="2" align='center'>证明文件名称</td>
                                        <td colSpan="1" align='center'>备  注</td>
                                    </tr>
                                    <tr>
                                        <td height="60;" colSpan="1" align='center'>1</td>
                                        <td colSpan="2" >
                                            本企业制定了《研发项目管理制度》，规定项目立项前应进行可行性分析，
                                            对市场需求和技术现状进行充分调查，在立项审批过程中必须提交立项建议书，
                                            交由总经理审批，项目立项后，应通过制定或竞争方式成立项目研发小组，
                                            项目组应抽调合适人员，制定工作任务和时间点。项目研发阶段结束后，
                                            必须由总经理、研发中心联合评审方可验收结题。有较大市场价值的技术创新和技术成果，
                                            应及时进行专利申请。根据《高新技术企业认定管理办法》等文件，
                                            制定了《研发投入核算管理制度》《研发辅助账管理办法》《企业研发准备金制度》。
                                        </td>
                                        <td colSpan="2">
                                            《研发项目管理制度》
                                            《研发资金投入核算投入管理办法》
                                            《研发辅助账管理办法》
                                            《企业研发准备金制度》
                                        </td>
                                        <td colSpan="1">

                                        </td>
                                    </tr>
                                    <tr>
                                        <td height="60;" colSpan="1" align='center'>2</td>
                                        <td colSpan="2" >
                                            本企业设立了内部研发机构，根据研发需求，采购相应设备，
                                            建立研发中心，并积极开展产学研，
                                            并与
                                            {
                                                this.state.edit_status === false?
                                                    <Input
                                                        defaultValue={this.state.school}
                                                        autoSize={{ minRows: 1, maxRows: 2 }}
                                                        onChange={this.schoolChange.bind(this)}
                                                    />:
                                                    this.state.school
                                            }
                                            签订产学研协议。
                                        </td>
                                        <td colSpan="2">
                                            《关于成立研发中心的通知》
                                            《研发中心建设情况说明》
                                            研发部照片和研发设备照片
                                            产学研合作协议
                                        </td>
                                        <td colSpan="1">

                                        </td>
                                    </tr>
                                    <tr>
                                        <td height="60;" colSpan="1" align='center'>3</td>
                                        <td colSpan="2" >
                                            本企业建立了科技成果转化的组织实施与激励奖励制度，
                                            规定研发人员按照项目参与程度、重要性原则和成果原则进行绩效考核。
                                            为营造充满生机活力的创新创业生态环境，大力推进众创空间建设，
                                            建立开放式的创新创业平台。
                                            本公司现在有科技成果转化{this.state.organizationItem.count}项，
                                            平均每年{this.state.organizationItem.average}项以上。
                                        </td>
                                        <td colSpan="2">
                                            《科技成果转化的组织实施与激励奖励制度》
                                            《开放式创新创业平台制度》
                                        </td>
                                        <td colSpan="1">

                                        </td>
                                    </tr>
                                    <tr>
                                        <td height="60;" colSpan="1" align='center'>4</td>
                                        <td colSpan="2">
                                            本企业按照现代企业管理制度，建立了科技人员的培养进修、
                                            职工技能培训、优秀人才引进，以及人才绩效评价奖励制度
                                        </td>
                                        <td colSpan="2">
                                            《科技人员培训管理制度》
                                            《科技人员培养进修制度》
                                            《人才引进制度》
                                            《研发人员绩效考核制度》
                                        </td>
                                        <td colSpan="1">

                                        </td>
                                    </tr>
                                </table>:
                                <table border="1" className='table'>
                                    <tr>
                                        <td height="60;" colSpan="1" align='center'>序号</td>
                                        <td colSpan="2" width="40%" align='center'>研究开发组织管理内容</td>
                                        <td colSpan="2" align='center'>证明文件名称</td>
                                        <td colSpan="1" align='center'>备  注</td>
                                    </tr>
                                    <tr>
                                        <td height="60;" colSpan="1" align='center'>1</td>
                                        <td colSpan="2" >
                                            本企业制定了《研发项目管理制度》，规定项目立项前应进行可行性分析，
                                            对市场需求和技术现状进行充分调查，在立项审批过程中必须提交立项建议书，
                                            交由总经理审批，项目立项后，应通过制定或竞争方式成立项目研发小组，
                                            项目组应抽调合适人员，制定工作任务和时间点。项目研发阶段结束后，
                                            必须由总经理、研发中心联合评审方可验收结题。有较大市场价值的技术创新和技术成果，
                                            应及时进行专利申请。根据《高新技术企业认定管理办法》等文件，
                                            制定了《研发投入核算管理制度》《研发辅助账管理办法》《企业研发准备金制度》。
                                        </td>
                                        <td colSpan="2">
                                            《研发项目管理制度》
                                            《研发资金投入核算投入管理办法》
                                            《研发辅助账管理办法》
                                            《企业研发准备金制度》
                                        </td>
                                        <td colSpan="1">

                                        </td>
                                    </tr>
                                    <tr>
                                        <td height="60;" colSpan="1" align='center'>2</td>
                                        <td colSpan="2" >
                                            本企业建立了科技成果转化的组织实施与激励奖励制度，
                                            规定研发人员按照项目参与程度、重要性原则和成果原则进行绩效考核。
                                            为营造充满生机活力的创新创业生态环境，大力推进众创空间建设，
                                            建立开放式的创新创业平台。
                                            本公司现在有科技成果转化
                                            {this.state.organizationItem.count}
                                            项，
                                            平均每年{this.state.organizationItem.average}项以上。
                                        </td>
                                        <td colSpan="2">
                                            《科技成果转化的组织实施与激励奖励制度》
                                            《开放式创新创业平台制度》
                                        </td>
                                        <td colSpan="1">

                                        </td>
                                    </tr>
                                    <tr>
                                        <td height="60;" colSpan="1" align='center'>3</td>
                                        <td colSpan="2" >
                                            本企业按照现代企业管理制度，建立了科技人员的培养进修、
                                            职工技能培训、优秀人才引进，以及人才绩效评价奖励制度
                                        </td>
                                        <td colSpan="2">
                                            《科技人员培训管理制度》
                                            《科技人员培养进修制度》
                                            《人才引进制度》
                                            《研发人员绩效考核制度》
                                        </td>
                                        <td colSpan="1">

                                        </td>
                                    </tr>
                                </table>
                        }
                        <div>
                            <Button type="primary" className="submit-edit-button" onClick={this.submit.bind(this)}>提交</Button>
                            <Button
                                type="primary" className="submit-edit-button" onClick={this.edit.bind(this)}>编辑</Button>
                        </div>
                    </Card>
                </Space>
                <Modal
                    visible={this.state.preview_visible}
                    title={'预览'}
                    onCancel={this.hideModal}
                    destroyOnClose
                    width={'60%'}
                    footer={[
                        <Button key="back" onClick={this.hideModal}>
                            取消
                        </Button>,
                        <Button key="back"  type="primary" onClick={this.download.bind(this)}>
                            下载
                        </Button>,
                    ]}
                >
                    <FileViewer fileType='pdf'
                                filePath={this.state.fileStream}
                                onError={this.onError}
                    />
                </Modal>
                <Modal
                    visible={this.state.upload_visible}
                    title={'上传附件'}
                    onCancel={this.hideModal.bind(this)}
                    destroyOnClose
                    footer={[
                        <Button key="back" onClick={this.hideModal.bind(this)}>
                            取消
                        </Button>,
                        <Button key="submit" type="primary" onClick={this.hideModal.bind(this)}>
                            完成
                        </Button>,
                    ]}
                >
                    <div>
                        该公司的研究开发组织管理水平指标逐项说明
                        {this.state.checkStatus === true?<Tag color="green" className="Tag_style">已上传</Tag>:<Tag color="red" className="Tag_style">未上传</Tag>}
                        <Form style={{marginTop:'20px'}}>
                            <Form.Item
                                name='file'
                                method="post"
                                enctype="multipart/form-data"
                            >
                                <input
                                    type="file"
                                    name='file'
                                    onChange={this.fileInput.bind(this)}
                                />
                            </Form.Item>
                            <Form.Item name="preview_paper">
                                {
                                    this.state.checkStatus === true &&
                                    <div>
                                        <Button type={"primary"} onClick={this.deleteUpload.bind(this)}>删除</Button>
                                        <FileViewer fileType='pdf'
                                                    filePath={this.state.fileStream_upload}
                                                    onError={this.onError}
                                        />
                                    </div>
                                }
                            </Form.Item>
                        </Form>
                    </div>
                </Modal>
                <Modal
                    visible={this.state.uploadFile_visible}
                    title={'上传'}
                    onCancel={this.hideModalTwo.bind(this)}
                    destroyOnClose
                    footer={[
                        <Button key="back" onClick={this.hideModalTwo.bind(this)}>
                            取消
                        </Button>,
                        <Button key="submit" type="primary" onClick={this.uploadFile.bind(this)}>
                            确定
                        </Button>,
                    ]}
                >
                    <div>确定上传该研究开发组织管理水平指标逐项说明吗？</div>
                </Modal>
            </div>
        )
    }
}

export default OrganizationItem;